function TranslationDiv(props) {
    /*
    // https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
    function generateUUID() { // Public Domain/MIT
        var d = new Date().getTime();//Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;//random number between 0 and 16
            if (d > 0) {//Use timestamp until depleted
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {//Use microseconds since page-load if supported
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
        })};
        */
    function parseObjectKeys(obj, arr = []) {
        for (var prop in obj) {
            var sub = obj[prop];
            if (typeof (sub) == "object") {
                parseObjectKeys(sub);
                arr.push([prop, sub]);
            }
        }
    }

    const trArr = [];
    parseObjectKeys(props.international, trArr);

    let translations = [];
    for (let i = 0; i < trArr.length; i++) {
        for (let j = 0; j < trArr[i].length; j++) {
            if (trArr[i][j].official) {
                translations = [...translations, [{ 'id' : `${trArr[i][0]}${i}`}, { 'language': trArr[i][0] }, { 'official': trArr[i][j].official }, { 'common': trArr[i][j].common }]];
            }
        }
    }

    return (
        <div className="columns is-mobile is-multiline">
                {translations.map((row) => {
                    return (
                        <div key={row[0].id} className="column is-half-mobile is-one-third-desktop">
                            <div className="is-one-sixth-desktop"><strong>{ row[1].language.toUpperCase() }</strong></div>
                            <div className="is-one-sixth-desktop"><em>official:</em></div>
                            <div className="is-one-sixth-desktop">{ row[2].official }</div>
                            <div className="is-one-sixth-desktop"><em>common:</em></div>
                            <div className="is-one-sixth-desktop">{ row[3].common }</div>
                        </div>
                    );
                })}
        </div>
    )
}

export default TranslationDiv;